// Dependencies
import styled from 'styled-components'

export const ContentWrapper = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 40px;
  padding: 40px;
  width: 100%;
  background-color: #fff;
  z-index: 5;
  flex-shrink: 0;
  position: relative;

  @media (min-width: 768px) {
    max-width: 600px;
    border-radius: 8px;
    height: unset;
  }
`

export const CloseIconWrapper = styled.div`
  width: fit-content;
  cursor: pointer;

  position: absolute;
  top: 16px;
  right: 16px;
`

export const TitleWrapper = styled.div`
  display: block;
`

export const ContentTitle = styled.h3`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 32px;
  font-weight: 900;
  line-height: 38px;
  color: #3a3e47;
`

export const ContentSubtitle = styled.p`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #3a3e47;
`

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const CancelButtonElementWrapper = styled.div`
  width: fit-content;
`
